import classes from "./Spinner.module.css";

const Spinner = ({ text }) => {
  const spinnerText = text || "Loading Secure Form";

  return (
    <div className={classes.wrapper}>
      <div className={classes.loader} />
      <p className={classes.spinnerText}>{spinnerText}</p>
    </div>
  );
};

export default Spinner;
